import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useSearchParams } from "react-router-dom";
import { Clock } from "lucide-react";

/* Cinematic bridge · 4 s · "Six months later…" */
const GOLD = "#C9A24A";
const NAVY = "#0A1F44";

export default function AltaraTransitionDemo() {
  const [params] = useSearchParams();
  const embed = params.get("embed") === "1";
  const scene = (
    <div className="relative w-full h-full overflow-hidden flex flex-col items-center justify-center" data-testid="altara-transition" style={{ background: NAVY }}>
      <motion.div initial={{ opacity: 0, scale: 0.7 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.8 }}
        className="flex items-center justify-center rounded-full mb-8"
        style={{ width: 96, height: 96, border: `2px solid ${GOLD}`, boxShadow: `0 0 40px ${GOLD}55` }}>
        <Clock size={48} color={GOLD} strokeWidth={1.6} />
      </motion.div>
      <motion.div className="uppercase tracking-[0.6em] text-sm mb-6" style={{ color: GOLD }}
        initial={{ opacity: 0, letterSpacing: "0.2em" }} animate={{ opacity: 1, letterSpacing: "0.6em" }}
        transition={{ delay: 0.5, duration: 0.9 }}>
        Six months later
      </motion.div>
      <motion.div className="text-white text-5xl font-extrabold text-center max-w-4xl leading-tight px-8"
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.0, duration: 0.9 }}>
        Something feels off.
      </motion.div>
      <motion.div style={{ height: 2, width: 120, background: GOLD, marginTop: 24, transformOrigin: "left" }}
        initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ delay: 1.8, duration: 0.7 }} />
    </div>
  );
  if (embed) return <div className="w-screen h-screen" style={{ background: NAVY }}>{scene}</div>;
  return <div className="w-full" style={{ background: NAVY, minHeight: "100vh" }}>
    <div className="mx-auto" style={{ maxWidth: 1600, aspectRatio: "16/9" }}>{scene}</div>
  </div>;
}
